import React, { useState, useEffect } from 'react';
import { Table, Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { HVAScorecardQuestion } from 'services/hvascorecard.service';

interface ScorecardQuestionsListProps {
  questions: HVAScorecardQuestion[];
  onQuestionsChange: (questions: HVAScorecardQuestion[]) => void;
}

const defaultNewQuestion: HVAScorecardQuestion = {
  questionorder: 0,
  questiontitle: '',
  questiontext: '',
  questionweight: 0,
  answerformat: ''
};

const ScorecardQuestionsList: React.FC<ScorecardQuestionsListProps> = ({
  questions,
  onQuestionsChange
}) => {
  const [newQuestion, setNewQuestion] =
    useState<HVAScorecardQuestion>(defaultNewQuestion);

  useEffect(() => {
    setNewQuestion(defaultNewQuestion);
  }, [questions]);

  const handleAddQuestion = () => {
    const updatedQuestions = [...questions, { ...newQuestion, id: Date.now() }];
    onQuestionsChange(updatedQuestions);
    setNewQuestion(defaultNewQuestion);
  };

  const handleRemoveQuestion = (id: number | undefined) => {
    if (id === undefined) {
      console.error('Cannot remove question with undefined id');
      return;
    }
    const updatedQuestions = questions.filter(q => q.id !== id);
    onQuestionsChange(updatedQuestions);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setNewQuestion(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div>
      <h5>Scorecard Questions</h5>
      <Table className="phoenix-table">
        <thead className="fs-9 pt-2 pb-1 border_bottom">
          <tr>
            <th className="px-2 pb-1">Order</th>
            <th className="pb-1">Title</th>
            <th className="pb-1">Question</th>
            <th className="pb-1">Answer Format</th>
            <th className="pb-1">Weight</th>
            <th className="pb-1"></th>
          </tr>
        </thead>
        <tbody className="fs-9 pt-0 pb-0">
          {questions.map((question, index) => (
            <tr key={question.id || index} className="pt-0 pb-0 border_bottom">
              <td className="px-3 pt-1 pb-1">{question.questionorder}</td>
              <td className="pt-1 pb-1">{question.questiontitle}</td>
              <td className="pt-1 pb-1">{question.questiontext}</td>
              <td className="pt-1 pb-1">{question.answerformat}</td>
              <td className="px-3 pe-0 pt-1 pb-1">{question.questionweight}</td>
              <td className="pe-2 pt-1 pb-1">
                <Button
                  variant="primary"
                  size="sm"
                  // eslint-disable-next-line
                  onClick={() => question.id !== undefined && handleRemoveQuestion(question.id)}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </Button>
              </td>
            </tr>
          ))}
          <tr className="bg-body">
            <td className="px-2">
              <Form.Control
                type="number"
                name="questionorder"
                value={newQuestion.questionorder}
                onChange={handleInputChange}
                placeholder="Order"
              />
            </td>
            <td>
              <Form.Control
                type="text"
                name="questiontitle"
                value={newQuestion.questiontitle}
                onChange={handleInputChange}
                placeholder="Title"
              />
            </td>
            <td>
              <Form.Control
                type="text"
                name="questiontext"
                value={newQuestion.questiontext}
                onChange={handleInputChange}
                placeholder="Text"
              />
            </td>
            <td>
              <Form.Control
                type="text"
                name="answerformat"
                value={newQuestion.answerformat}
                onChange={handleInputChange}
                placeholder="Answer Format"
              />
            </td>
            <td>
              <Form.Control
                type="number"
                name="questionweight"
                value={newQuestion.questionweight}
                onChange={handleInputChange}
                placeholder="Weight"
              />
            </td>
            <td>
              <Button variant="primary" size="sm" onClick={handleAddQuestion}>
                <FontAwesomeIcon icon={faPlus} />
              </Button>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default ScorecardQuestionsList;
